export default "__VITE_ASSET__cOkXvNxV__"